import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import ProgressDialog from '@afosto/app-components-react/ProgressDialog';
import translations from './translations';

const CancelOrderProgressDialog = ({ isOpen }) => {
  const intl = useIntl();

  return <ProgressDialog isOpen={isOpen} message={intl.formatMessage(translations.message)} />;
};

CancelOrderProgressDialog.propTypes = {
  isOpen: PropTypes.bool,
};

CancelOrderProgressDialog.defaultProps = {
  isOpen: false,
};

export default CancelOrderProgressDialog;
